
import { Vue, Prop, Component } from 'nuxt-property-decorator'

@Component
export default class BlackFridayBlogCard extends Vue {
  @Prop({ type: String, required: true })
  readonly image!: string

  @Prop({ type: String, required: true })
  readonly header!: string

  @Prop({ type: String, required: true })
  readonly text!: string

  @Prop({ type: String, required: true })
  readonly url!: string
}
